module.exports = __webpack_public_path__ + "img/level_three_hover.6b2dc828.png";